import {commonPromise} from '../../http'
import {
    ACTIVITY_LIST,
    ACTIVITY_DETAILS,
    QUERY_MUSEUM_INFO
} from '../global'

export const activityListFetch = (data) => commonPromise(data, ACTIVITY_LIST);// 获取假日出发活动列表
export const activityDetailsFetch = (data) => commonPromise(data, ACTIVITY_DETAILS);// 获取假日出发活动列表
export const queryMuseumInfo = (data) => commonPromise(data, QUERY_MUSEUM_INFO)// 博物馆列表


// WEBPACK FOOTER //
// ./src/api/apiModules/vocationApi.js